import React from 'react';
import { Factory, ShoppingBag } from 'lucide-react';
export function TechnologySection() {
  return <section id="solution" className="bg-gradient-to-b from-[#fafafa] to-[#f5f5f5] py-32 md:py-40 px-7 md:px-40" data-id="element-134">
      <div className="max-w-6xl mx-auto" data-id="element-135">
        <div className="mb-24 max-w-4xl mx-auto px-8" data-id="element-136">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4 text-left" data-id="element-137">
            Our Solution
          </p>
          <h2 className="text-4xl md:text-6xl font-light text-[#1a1a1a] leading-tight text-center" data-id="element-138">
            We Create Value throughout the Supply Chain
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-139">
          {/* Manufacturers Card */}
          <div className="bg-white p-10 md:p-16 shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-140">
            <div className="w-12 h-12 bg-[#f0f5f9] flex items-center justify-center mb-8 text-[#1e3a5f]" data-id="element-141">
              <Factory size={24} data-id="element-142" />
            </div>
            <h3 className="text-lg font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-143">
              For Manufacturers
            </h3>
            <h4 className="text-3xl md:text-4xl font-semibold text-[#1a1a1a] mb-6" data-id="element-144">
              We are your data-driven distribution arm.
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed mt-auto" data-id="element-145">
              We identify under-supplied, high demand sales channels for your
              goods; find buyers; and increase your sales and profits.
            </p>
          </div>

          {/* Retailers Card */}
          <div className="bg-[#1e3a5f] p-10 md:p-16 shadow-xl flex flex-col h-full text-white hover:shadow-2xl transition-shadow duration-300" data-id="element-146">
            <div className="w-12 h-12 bg-white/10 flex items-center justify-center mb-8 text-white" data-id="element-147">
              <ShoppingBag size={24} data-id="element-148" />
            </div>
            <h3 className="text-lg font-bold uppercase tracking-widest text-white/60 mb-4" data-id="element-149">
              For Online Retailers
            </h3>
            <h4 className="text-3xl md:text-4xl font-semibold text-white mb-6" data-id="element-150">
              We are your outsourced procurement team.
            </h4>
            <p className="text-lg text-white/80 leading-relaxed mt-auto" data-id="element-151">
              We surface high-margin, fast-selling products tailored to your
              retail channel; and facilitate the transaction from purchase to
              delivery.
            </p>
          </div>
        </div>
      </div>
    </section>;
}